import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ParentData, ParentService } from '../../services/parent.service';
import { Utils } from '../../util';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { toast } from 'angular2-materialize';

@Component({
  selector: 'app-update-parent',
  templateUrl: './update-parent.component.html',
  styleUrls: ['./update-parent.component.css']
})
export class UpdateParentComponent implements OnInit {

  id: string

  form: FormGroup;
  assignmentsSelect: {value: string, name: string}[];
  assignments: string[] = [];
  assignment: string = '';

 
  pickadateParams = Utils.pickadateParams();

  constructor(
    private service: ParentService,
    private data: ParentData,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.assignmentsSelect = Object.keys(data.assignments).map(key => {
      return {value: key, name: data.assignments[key]}
    }); 
    this.assignment = this.assignmentsSelect[0].value;
  }

  ngOnInit() {
    this.createForm();
    let sub = this.service.getParent(this.id).subscribe(parent => {
      sub.unsubscribe();
      let {name, birthdate, semester, assignments = []}  = parent;
      this.form.setValue({name, birthdate, semester})
      console.log(assignments)
      this.assignments = assignments;
    }) 
  }

  createForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      birthdate: ['', Validators.required],
      semester: [1, [Validators.required, Validators.min(1), Validators.max(12)]],
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let parent = {
      assignments: this.assignments,
      ...value
    }
    
    this.service.updateParent(this.id, parent);
    this.service.windowReplace('read');
  }

  touchAssignment(){
    if(this.assignments.includes(this.assignment)) return toast('you can not add duplicates.', 3000);
    this.assignments.push(this.assignment)
  }
  removeAssignment(index: number){
    this.assignments.splice(index, 1);
  }

}